/**
 * Created by Mark on 23/11/2016.
 */


import request from 'reqwest';
import when from 'when';
import EnvironmentConstants from '../constants/environment.js';
import { hashHistory  , browserHistory, Router, Route, Link, withRouter } from 'react-router'
import AuthenticationStore from '../store/authentication-store.js';
import AuthenticationActions from '../actions/authentication.actions.js';
class BaseService {

    addDataConstants(data){
        data.systemUID = EnvironmentConstants.APPLICATION_SYSTEM_UID;
        data.token     = sessionStorage.getItem('token');
        return data;
    }

    handleService(url, data) {
        return when(request({
            url:url,
            method: 'post',
            data:this.addDataConstants(data),
            crossOrigin: true,
            type: 'json'
        }));
    }

    call(url , data){

        return new Promise(function(resolve){

            this.handleService(url , data).then(function(response){

                if (response.Error == "U1") {
                    AuthenticationActions.authenticateUser(null);
                    sessionStorage.removeItem('token');

                    if(sessionStorage.getItem("resources_authentication"))
                        return window.location.href = window.location.origin + "/resources/#/LoginScreen";
                    else
                        hashHistory.push('/authenticate')
                } else {

                    if(response.newToken)
                    {
                        AuthenticationActions.authenticateUser(response.newToken);
                    }

                    resolve(response);
                }
            });
        }.bind(this));
    }
}


export default new BaseService();


// WEBPACK FOOTER //
// ./src/services/base-service.js